const data = {
  id: 1,
  title: 'Read and complete the paragraph with the given words.',
  subTitle: 'Đọc và điền từ để hoàn thành đoạn văn',
  words: ['name', 'My', 'meet'],
  questions: ['A: What’s your # ?', "B: # name’s Hoa.", 'A: Nice to # you.'],
  answers: ['name', 'My', 'meet'],
  settings: {
    showNumber: false,
  },
};

export default data;
